module.exports = __webpack_public_path__ + "static/img/sjzlpt1.50de8540.jpeg";